/**
 * Redis channel for a tenant's audit-change nudges; deliberately compile-time,
 * not Helm config — the same posture as `COLLAB_BOARD_STATUS_CHANNEL`.
 *
 * Its OWN namespace, never `pb:notification:bell:*`. The notification service
 * relays both onto one socket, so the two must stay separable at the transport
 * even though they share a connection.
 */
export function auditEventsChannel(tenantId) {
    return `pb:audit:events:v1:${tenantId}`;
}
/**
 * Parse a relayed frame, FAILING CLOSED: anything that is not exactly this
 * envelope answers `null` rather than a partially-trusted object.
 *
 * Deliberately strict about `v` and `type` so a future version cannot be
 * mistaken for this one, and so a bell frame — or any other traffic that
 * reaches the same socket — can never be read as an audit nudge.
 */
export function parseAuditChangedEvent(data) {
    let raw = data;
    if (typeof data === "string") {
        try {
            raw = JSON.parse(data);
        }
        catch {
            return null;
        }
    }
    if (typeof raw !== "object" || raw === null)
        return null;
    const record = raw;
    if (record["v"] !== 1)
        return null;
    if (record["type"] !== "audit.changed")
        return null;
    const tenantId = record["tenantId"];
    const ts = record["ts"];
    if (typeof tenantId !== "string" || tenantId === "")
        return null;
    if (typeof ts !== "string" || ts === "")
        return null;
    return { v: 1, type: "audit.changed", tenantId, ts };
}
//# sourceMappingURL=audit-events.js.map